import { __module as t } from "../../../../_virtual/interopRequireDefault.js";
var u;
function n() {
  return u ? t.exports : (u = 1, function(e) {
    function o(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(t), t.exports);
}
export {
  n as __require
};
